import React from 'react';
import { useAvailableQuizzState } from '../../hooks';
import { useNavigate } from 'react-router';
import { ERoutes } from '../../enums';

export const WithQuizzQuard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const isQuizzActive = useAvailableQuizzState();
  const navigate = useNavigate();

  if (!isQuizzActive) {
    navigate(ERoutes.main);
    return;
  }

  return children;
};
